import { render, staticRenderFns } from "./ImgTurnPage.vue?vue&type=template&id=3f717e51&scoped=true&"
import script from "./ImgTurnPage.vue?vue&type=script&lang=js&"
export * from "./ImgTurnPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f717e51",
  null
  
)

export default component.exports